import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api/api';
import { notify } from '../utils/notifications';
import '../styles/OnboardingBanner.css';

function OnboardingBanner() {
    const { userProfile } = useAuth();
    const [dismissing, setDismissing] = useState(false);

    if (!userProfile || userProfile.onboarding_dismissed_at) {
        return null;
    }

    const handleDismiss = async () => {
        setDismissing(true);
        try {
            await api.put('/user/profile', { onboarding_dismissed: true });
        } catch (error) {
            console.error('Failed to dismiss onboarding banner:', error);
            notify.error('Failed to dismiss banner. Please try again.');
        } finally {
            setDismissing(false);
        }
    };

    return (
        <div className="onboarding-banner">
            <div className="onboarding-banner-header">
                <h3>Quick Start Guide</h3>
                <button
                    className="onboarding-dismiss"
                    onClick={handleDismiss}
                    disabled={dismissing}
                >
                    {dismissing ? 'Dismissing...' : 'Got it'}
                </button>
            </div>
            <div className="onboarding-steps">
                <div className="onboarding-step">
                    <span className="step-number">1</span>
                    <div className="step-content">
                        <h4>Upload</h4>
                        <p>Create a new case and upload patient documents (PDF or DOCX).</p>
                    </div>
                </div>
                <div className="onboarding-step">
                    <span className="step-number">2</span>
                    <div className="step-content">
                        <h4>Review</h4>
                        <p>AI extracts structured clinical data. Review and edit as needed.</p>
                    </div>
                </div>
                <div className="onboarding-step">
                    <span className="step-number">3</span>
                    <div className="step-content">
                        <h4>Generate</h4>
                        <p>Generate the HPI and diagnosis from your reviewed data.</p>
                    </div>
                </div>
                <div className="onboarding-step">
                    <span className="step-number">4</span>
                    <div className="step-content">
                        <h4>Finalize</h4>
                        <p>Copy or export the completed assessment for your records.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OnboardingBanner;
